import * as React from 'react';
import classnames from 'classnames';
import { ConfiguratorModal } from '../ConfiguratorModal/ConfiguratorModal.js';
import '@swc/helpers';
import '@grandvisionhq/state';
import '@grandvisionhq/utils';
import '../../state/selectors.internal.js';
import '@grandvisionhq/iris-ui';
import { ConfiguratorStepContainer } from '../ConfiguratorStep/ConfiguratorStepContainer.js';
import { ConfiguratorFooter } from '../Footer/ConfiguratorFooter.js';
import { ConfiguratorHeaderContainer } from '../Header/ConfiguratorHeaderContainer.js';
import { ConfiguratorMainContainer } from '../Main/ConfiguratorMainContainer.js';

const Configurator = ({ 'data-t': dataT , className , isOpen , preventVerticalScroll ,  })=>/*#__PURE__*/ React.createElement(ConfiguratorModal, {
        isOpen: isOpen,
        preventVerticalScroll: preventVerticalScroll
    }, /*#__PURE__*/ React.createElement("div", {
        "data-t": dataT,
        className: classnames('configurator', className)
    }, /*#__PURE__*/ React.createElement(ConfiguratorHeaderContainer, null), /*#__PURE__*/ React.createElement(ConfiguratorMainContainer, {
        className: "configurator__main"
    }, /*#__PURE__*/ React.createElement(ConfiguratorStepContainer, null)), /*#__PURE__*/ React.createElement(ConfiguratorFooter, null)))
;

export { Configurator };
//# sourceMappingURL=Configurator.js.map
